import React from 'react';
import { UIIcon } from '@dropbox/dig-icons';
import { UnorderedListLine } from '@dropbox/dig-icons/assets';

export function FixErrorsIcon() {
  return (
    <UIIcon src={UnorderedListLine} />
  );
}
